import * as era from '!/era'

export * as model from './model'
export { HomePage } from './ui'

// skin
export const skin = era.skin('routes/home/root')
